import Skeleton from '@material-ui/lab/Skeleton'
import * as React from 'react'

import styled from 'styled-components'
import { createMuiTheme, ThemeProvider } from '@material-ui/core'

const ItemDiv = styled.div`
  display: flex;
  flex-direction: column;

  margin: 0 0 10px 0;
  width: 100%;
  background: linear-gradient(rgb(35, 35, 35), rgb(20, 20, 20));
  border-color: #323232;
  border-width: 1px;
  border-style: solid;
  border-radius: 15px;
`

const DetailsDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  margin: 10px;
  z-index: 1;
`

const HeaderDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 8px;
`

const VideoTitle = styled.div`
  color: white;
  text-align: left;
  font-weight: 700;
  font-size: 22px;
  white-space: nowrap;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
`

const Subtitle = styled.div`
  color: white;
  font-weight: 500;
  font-size: 1.1rem;
`

const CreatorDiv = styled.div`
  display: inline-flex;
  align-items: center;
  flex-direction: row;
  border-radius: 30px;
  height: 24px;
  background: #444;
  width: fit-content;
  padding: 8px;
  margin-top: 8px;
  margin-bottom: 8px;
`

const theme = createMuiTheme({
  palette: {
    type: 'dark',
  },
})

export const SkeletonItem = (): JSX.Element => {
  return (
    <ThemeProvider theme={theme}>
      <ItemDiv>
        <DetailsDiv>
          <CreatorDiv>
            <Skeleton animation="pulse" variant="circle" width={'25px'} height={'25px'} />
          </CreatorDiv>
          <HeaderDiv>
            <Subtitle>
              <Skeleton animation="pulse" variant="text" width={'50px'} />
            </Subtitle>
            <VideoTitle>
              <Skeleton animation="wave" variant="text" />
            </VideoTitle>
          </HeaderDiv>
          <Subtitle>
            <Skeleton animation="pulse" variant="text" width={'50px'} />
            <Skeleton animation="pulse" variant="text" width={'50px'} />
          </Subtitle>
        </DetailsDiv>
      </ItemDiv>
    </ThemeProvider>
  )
}

export default SkeletonItem
